import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { Input, TableColumnsType } from "antd"
import { useNavigate } from "react-router-dom"
import { useGet } from "utils/useFetch"
import { IEmployeeOkrCount, IEmpOkr } from "../../interface/individual"
import { AppTable, TableActionSelect } from "components/new-stuff/app-table"
interface props {
  MEMURL: string
  id: number | null
  selectedCycle: number | null
  navigateURL: string
}
const MembersTab = ({ MEMURL, id, selectedCycle, navigateURL }: props) => {
  const navigate = useNavigate()

  const {
    isLoading: isLoading,
    data: indData,
    refetch,
  } = useGet<IEmployeeOkrCount>({
    url: `${MEMURL}`,
    instanceKey: "newArchAxiosInstance",
    enabled: !!id,
  })

  const TableColumns: TableColumnsType<IEmpOkr> = [
    {
      title: "Employee",
      dataIndex: "employeeName",
    },
    {
      title: "No. of Objectives",
      dataIndex: "objectiveCount",
      width: 150,
    },
    {
      title: "No. of Key Results",
      dataIndex: "keyResultCount",
      width: 150,
    },
    {
      title: "",
      dataIndex: "Action",
      render: (_: any, record: IEmpOkr) => (
        <TableActionSelect items={actionItems(record)} />
      ),
    },
  ]

  const actionItems = (record: IEmpOkr) => {
    return [
      {
        key: "1-view",
        label: (
          <button
            className="font-circular !text-neutral400 w-full text-left"
            onClick={() =>
              navigate(
                `${navigateURL}?x=${record?.employeeKey || record?.employeeId}`,
                {
                  state: {
                    employeeName: record?.employeeName,
                    employeeId: record?.employeeId,
                  },
                }
              )
            }
            // onClick={() => setIndividualSelected(true)}
          >
            View
          </button>
        ),
      },
    ]
  }
  return (
    <>
      <div className="p-5 bg-white flex items-center gap-2.5">
        <Input
          placeholder="Search Employee"
          prefix={<MagnifyingGlassIcon className="w-4 h-4 text-neutral-300" />}
          className="font-avenir w-[268px] "
        />
      </div>
      <div>
        <AppTable
          columns={TableColumns}
          dataSource={indData?.data?.employees ?? []}
          loading={isLoading}
          className="text-[#42526D] justify-between"
          pagination={false}
        />
      </div>
    </>
  )
}

export default MembersTab
